import axios from 'axios';
import router from "@/router";

let state = {
    elevatorMotor_Machine_Manual: {},

    // elevatorMotor_Brake
    elevatorMotor_Brake_Manual_Data: {},
    elevatorMotor_Brake_Selections_Shown: true,

    // elevatorMotor_Brake_MechanicalRelease
    elevatorMotor_Brake_MechanicalRelease_ChangedByUser: false,
    // elevatorMotor_Brake_ReleaseMonitoring
    elevatorMotor_Brake_ReleaseMonitoring_ChangedByUser: false,

    bowdenwireDeliverSelection: [],
    bowdenwireDetailsSelection: [],
    brakeConnectionSelection: {},
    rotatedBrakeReleaseSelection: [],

    // elevatorMotor_Encoder
    elevatorMotor_Encoder_Data: {},
    elevatorMotor_Encoder_Selection_Shown: true,
}

const actions = {
    change_driveTechnologies_toDefault_storeAction({ rootState, commit, dispatch }) {
        commit('change_elevatorMotor_Machine_Manual_storeMutation', {});
        dispatch('change_elevatorMotor_Brake_toDefault_storeAction');
        dispatch('change_elevatorMotor_Encoder_toDefault_storeAction');
    },

    async check_toDos_at_driveTechnologiesManual_storeAction({ rootState, commit, dispatch, rootGetters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        const inputData = (rootState.inputsManual.psg === true) ? rootGetters['psgModal/inputData'] : rootGetters['inputsManual/inputData'];

        const motorManual = {
            mTYP: inputData.mTYP,
            mBG: inputData.mBG,
            mFE: inputData.mFE,
            mZUS: inputData.mZUS,
            mU1: inputData.mU1,
            mNR: inputData.mNR,
            mLS_Law: inputData.mLS_Law,
            motor_Preference: inputData.motor_Preference,
            mSART: inputData.mSART,
            mIP: inputData.mIP,
            motor_ForcedVentilationWithBrakeRelease: inputData.motor_ForcedVentilationWithBrakeRelease,
            mFBTYP: inputData.mFBTYP,
            lTR: inputData.lTR,
            lTHD: inputData.lTHD,
            tD: inputData.tD,
            tB: inputData.tB,
            tARILL: inputData.tARILL,
            tAUWI: inputData.tAUWI,
            tAKWI: inputData.tAKWI,
            tCSD: inputData.tCSD,
            tDRA: inputData.tDRA,
            tDRZ: inputData.tDRZ,
            kIDSCH: inputData.kIDSCH,
            fUESSE: inputData.fUESSE,
            sEILAB: inputData.sEILAB,
            eINST: inputData.eINST,
            lSEILS: inputData.lSEILS,
            lTSABD: inputData.lTSABD,
            lTKLEM: inputData.lTKLEM,
            lRUEV: inputData.lRUEV,
            mN_SAS: inputData.mN_SAS,
            lTHD: inputData.lTHD,
            sM250_TS280: inputData.sM250_TS280,
            pSG_ProdAP: inputData.psg_ProdAP,
            pSG_Handradanbau: inputData.pSG_Handradanbau,
            pSG_Handlueftung: inputData.pSG_Handlueftung,
            pSG_Kabellaenge: inputData.pSG_Kabellaenge,
            pSG_KabellaengeBremse: inputData.pSG_KabellaengeBremse,
            pSG_Reglerart: inputData.pSG_Reglerart,
            pSG_NAM: inputData.pSG_NAM,
            pSG_Rillenform: inputData.pSG_Rillenform,
            pSG_Controller: inputData.psG_Controller,
            pSG_ID: inputData.pSG_ID,
        }

        const data = {
            motorManual: motorManual,
            kid: rootState.manualHome.kid,
        }

        await axios({
            method: 'post',
            url: '/api/driveTechnologiesManual/get_elevatorMotor_Machine_Manual_Informations',
            data: {
                data: data,
            }
        })
            .then((response) => {
                this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                if ((response.data.status.statusCode.substring(0, 1) == '2') || (response.data.status.statusCode.substring(0, 2) == '74') || (response.data.status.statusCode.substring(0, 2) == '75')) {
                    commit('change_elevatorMotor_Machine_Manual_storeMutation', response.data.data);
                    dispatch('get_elevatorMotor_Brake_Manual_Informations_storeAction');
                    dispatch('get_elevatorMotor_Encoder_Informations_storeAction');
                }
            })
            .catch(() => { })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },

    change_elevatorMotor_Brake_toDefault_storeAction({ commit }) {
        commit('change_elevatorMotor_Brake_Manual_Data_storeMutation', {});
        commit('change_elevatorMotor_Brake_Selections_Shown_storeMutation', true);
        commit('change_loader_forLoadingData_at_elevatorMotor_Brake_Shown_storeMutation', false);
        commit('change_elevatorMotor_Brake_MechanicalRelease_ChangedByUser_storeMutation', false);
        commit('change_elevatorMotor_Brake_ReleaseMonitoring_ChangedByUser_storeMutation', false);
        commit('change_bowdenwireDeliverSelection_storeMutation', []);
        commit('change_bowdenwireDeliverSelection_storeMutation', []);
        commit('change_brakeConnectionSelection_storeMutation', []);
        commit('change_rotatedBrakeReleaseSelection_storeMutation', []);
    },

    async get_elevatorMotor_Brake_Manual_Informations_storeAction({ rootState, dispatch, rootGetters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });


        var tnzbb = null;
        var tnbow = null;
        var bhl = null;
        var bksich = null;
        var bcspae = null;
        var bcspan = null;
        if (rootGetters['inputsManual/hasMotorManualData']) {
            tnzbb = rootState.inputsManual.motorManualData.details.tnzbb;
            tnbow = rootState.inputsManual.motorManualData.details.tnbow;
            bhl = rootState.inputsManual.motorManualData.details.bhl;
            bksich = rootState.inputsManual.motorManualData.details.bksich;
            bcspae = rootState.inputsManual.motorManualData.details.bcspae;
            bcspan = rootState.inputsManual.motorManualData.details.bcspan;
        }

        const inputData = (rootState.inputsManual.psg === true) ? rootGetters['psgModal/inputData'] : rootGetters['inputsManual/inputData'];

        const motorManual = {
            mTYP: inputData.mTYP,
            mBG: inputData.mBG,
            mFE: inputData.mFE,
            mZUS: inputData.mZUS,
            mU1: inputData.mU1,
            mNR: inputData.mNR,
            mLS_Law: inputData.mLS_Law,
            motor_Preference: inputData.motor_Preference,
            mSART: inputData.mSART,
            mIP: inputData.mIP,
            motor_ForcedVentilationWithBrakeRelease: inputData.motor_ForcedVentilationWithBrakeRelease,
            mFBTYP: inputData.mFBTYP,
            lTR: inputData.lTR,
            lTHD: inputData.lTHD,
            tD: inputData.tD,
            tB: inputData.tB,
            tARILL: inputData.tARILL,
            tAUWI: inputData.tAUWI,
            tAKWI: inputData.tAKWI,
            tCSD: inputData.tCSD,
            tDRA: inputData.tDRA,
            tDRZ: inputData.tDRZ,
            kIDSCH: inputData.kIDSCH,
            fUESSE: inputData.fUESSE,
            sEILAB: inputData.sEILAB,
            eINST: inputData.eINST,
            lSEILS: inputData.lSEILS,
            lTSABD: inputData.lTSABD,
            lTKLEM: inputData.lTKLEM,
            lRUEV: inputData.lRUEV,
            mN_SAS: inputData.mN_SAS,
            lTHD: inputData.lTHD,
            sM250_TS280: inputData.sM250_TS280,
            tnzbb: tnzbb,
            tnbow: tnbow,
            bhl: bhl,
            bksich: bksich,
            bcspae: bcspae,
            bcspan: bcspan,
            pSG_ProdAP: inputData.psg_ProdAP,
            pSG_Handradanbau: inputData.pSG_Handradanbau,
            pSG_Handlueftung: inputData.pSG_Handlueftung,
            pSG_Kabellaenge: inputData.pSG_Kabellaenge,
            pSG_KabellaengeBremse: inputData.pSG_KabellaengeBremse,
            pSG_Reglerart: inputData.pSG_Reglerart,
            pSG_NAM: inputData.pSG_NAM,
            pSG_Rillenform: inputData.pSG_Rillenform,
            pSG_Controller: inputData.psG_Controller,
            pSG_ID: inputData.psg_ID,
            //    psG_OrderStatusMotorCable: state.motorSchModData.psG_OrderStatusMotorCable,
            //    psG_OrderStatusEncoderCable: state.motorSchModData.psG_OrderStatusEncoderCable,
            //    psG_OrderStatusMotorProtectionCable: state.motorSchModData.psG_OrderStatusMotorProtectionCable,
            //    psG_OrderStatusBrakeCable: state.motorSchModData.psG_OrderStatusBrakeCable,
            //    psG_OrderStatusBrakeMonitoringCable: state.motorSchModData.psG_OrderStatusBrakeMonitoringCable,
            //    psG_OrderStatusForcedVentilationCable: state.motorSchModData.psG_OrderStatusForcedVentilationCable,
        }

        const data = {
            motorManual: motorManual,
            kid: rootState.manualHome.kid,
        }

        await axios({
            method: 'post',
            url: '/api/driveTechnologiesManual/get_elevatorMotor_Brake_Manual_Informations',
            data: {
                data: data,
            }
        })
            .then((response) => {
                this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);

                if ((response.data.status.statusCode.substring(0, 1) == '2') || (response.data.status.statusCode.substring(0, 2) == '74') || (response.data.status.statusCode.substring(0, 2) == '75')) {
                    dispatch('toDos_afterResponseOf_get_elevatorMotor_Brake_Manual_Informations_storeAction', response.data.data)
                    if (state.elevatorMotor_Brake_Manual_Data != null && state.elevatorMotor_Brake_Manual_Data.hasOwnProperty('elevatorMotor_Brake_Selection')) {
                        const firstIndex_whichMeetConditions = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => i.selected == true);
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_Selected_atFirstElementOf_elevatorMotor_Brake_Selection_toTrue_storeAction', firstIndex_whichMeetConditions);
                        }
                        else {
                            dispatch('change_Selected_atFirstElementOf_elevatorMotor_Brake_Selection_toTrue_storeAction', 0);
                        }
                    }
                    else {
                        dispatch('change_Selected_atFirstElementOf_elevatorMotor_Brake_Selection_toTrue_storeAction', 0);
                    }
                    dispatch('get_bowdenwireSelection_storeAction');
                    dispatch('get_brakeConnectionSelection_storeAction');
                    dispatch('get_rotatedBrakeReleaseSelection_storeAction');
                }

            })
            .catch(() => { })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },
    toDos_afterResponseOf_get_elevatorMotor_Brake_Manual_Informations_storeAction({ dispatch }, value) {
        dispatch('change_elevatorMotor_Brake_Manual_Data_storeAction', value.elevatorMotor_Brake_Data);
    },
    change_elevatorMotor_Brake_Manual_Data_storeAction({ commit }, value) {
        commit('change_elevatorMotor_Brake_Manual_Data_storeMutation', value);
    },
    change_elevatorMotor_Brake_Selections_Shown_storeAction({ commit }, value) {
        commit('change_elevatorMotor_Brake_Selections_Shown_storeMutation', value)
    },
    async change_Selected_atFirstElementOf_elevatorMotor_Brake_Selection_toTrue_storeAction({ commit, dispatch }, value) {
        dispatch('change_Selected_at_elevatorMotor_Brake_Selection_storeAction', value);
        dispatch('change_Selected_at_elevatorMotor_Brake_Voltage_Selection_basedOnChangesTo_Selected_at_elevatorMotor_Brake_Selection_storeAction');
        dispatch('change_Selected_at_elevatorMotor_Brake_MechanicalRelease_Selection_basedOnChangesTo_Selected_at_elevatorMotor_Brake_Selection_storeAction');
        dispatch('change_Selected_at_elevatorMotor_Brake_ReleaseMonitoring_Selection_basedOnChangesTo_Selected_at_elevatorMotor_Brake_Selection_storeAction');
        dispatch('change_Disabled_at_elevatorMotor_Brake_MechanicalRelease_Selection_basedOnChangesTo_Selected_at_elevatorMotor_Brake_Selection_storeAction');
        dispatch('change_Disabled_at_elevatorMotor_Brake_ReleaseMonitoring_Selection_basedOnChangesTo_Selected_at_elevatorMotor_Brake_Selection_storeAction');
    },
    change_Selected_at_elevatorMotor_Brake_Selection_storeAction({ commit }, value) {
        commit('change_Selected_at_elevatorMotor_Brake_Selection_storeMutation', value);
    },
    change_Selected_at_elevatorMotor_Brake_Selection_basedOnChangesTo_elevatorMotor_Brake_Voltage_storeAction({ commit, dispatch }, value) {
        var firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue = undefined;
        const firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => i.selected == true);

        if ((state.elevatorMotor_Brake_MechanicalRelease_ChangedByUser == false) && (state.elevatorMotor_Brake_ReleaseMonitoring_ChangedByUser == false)) {
            firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => i.elevatorMotor_Brake.nominalVoltage == value);
        }
        else if ((state.elevatorMotor_Brake_MechanicalRelease_ChangedByUser == true) && (state.elevatorMotor_Brake_ReleaseMonitoring_ChangedByUser == false)) {
            firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => ((i.elevatorMotor_Brake.nominalVoltage == value) && (i.elevatorMotor_Brake.mechanicalRelease == state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue].elevatorMotor_Brake.mechanicalRelease)))
            if (firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue == -1) {
                firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => i.elevatorMotor_Brake.nominalVoltage == value);
            }
        }
        else if ((state.elevatorMotor_Brake_MechanicalRelease_ChangedByUser == false) && (state.elevatorMotor_Brake_ReleaseMonitoring_ChangedByUser == true)) {
            firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => ((i.elevatorMotor_Brake.nominalVoltage == value) && (i.elevatorMotor_Brake.releaseMonitoring == state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue].elevatorMotor_Brake.releaseMonitoring)))
            if (firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue == -1) {
                firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => i.elevatorMotor_Brake.nominalVoltage == value);
            }
        }
        else if ((state.elevatorMotor_Brake_MechanicalRelease_ChangedByUser == true) && (state.elevatorMotor_Brake_ReleaseMonitoring_ChangedByUser == true)) {
            firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => ((i.elevatorMotor_Brake.nominalVoltage == value) && (i.elevatorMotor_Brake.mechanicalRelease == state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue].elevatorMotor_Brake.mechanicalRelease) && (i.elevatorMotor_Brake.releaseMonitoring == state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue].elevatorMotor_Brake.releaseMonitoring)))
            if (firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue == -1) {
                firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => i.elevatorMotor_Brake.nominalVoltage == value);
            }
        }

        if (firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue > -1) {
            dispatch('checkIf_changesAt_elevatorMotor_Brake_changes_configurationFlow_storeAction', firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue);
            dispatch('get_bowdenwireSelection_storeAction');
            dispatch('get_brakeConnectionSelection_storeAction');
            dispatch('get_rotatedBrakeReleaseSelection_storeAction');
        }
    },
    change_Selected_at_elevatorMotor_Brake_Selection_basedOnChangesTo_elevatorMotor_Brake_MechanicalRelease_storeAction({ commit, dispatch }, value) {
        var firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue = undefined;
        const firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => i.selected == true);

        firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => ((i.elevatorMotor_Brake.nominalVoltage == state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue].elevatorMotor_Brake.nominalVoltage) && (i.elevatorMotor_Brake.mechanicalRelease == value) && (i.elevatorMotor_Brake.releaseMonitoring == state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue].elevatorMotor_Brake.releaseMonitoring)));
        if (firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue == -1) {
            firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => ((i.elevatorMotor_Brake.nominalVoltage == state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue].elevatorMotor_Brake.nominalVoltage) && (i.elevatorMotor_Brake.mechanicalRelease == value)));
        }

        if (firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue > -1) {
            commit('change_elevatorMotor_Brake_MechanicalRelease_ChangedByUser_storeMutation', true);
            dispatch('checkIf_changesAt_elevatorMotor_Brake_changes_configurationFlow_storeAction', firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue);
            dispatch('get_bowdenwireSelection_storeAction');
            dispatch('get_brakeConnectionSelection_storeAction');
            dispatch('get_rotatedBrakeReleaseSelection_storeAction');
        }
    },
    change_Selected_at_elevatorMotor_Brake_Selection_basedOnChangesTo_elevatorMotor_Brake_ReleaseMonitoring_storeAction({ commit, dispatch }, value) {
        var firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue = undefined;
        const firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => i.selected == true);

        firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => ((i.elevatorMotor_Brake.nominalVoltage == state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue].elevatorMotor_Brake.nominalVoltage) && (i.elevatorMotor_Brake.mechanicalRelease == state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue].elevatorMotor_Brake.mechanicalRelease) && (i.elevatorMotor_Brake.releaseMonitoring == value)));

        if (firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue > -1) {
            commit('change_elevatorMotor_Brake_ReleaseMonitoring_ChangedByUser_storeMutation', true);
            dispatch('checkIf_changesAt_elevatorMotor_Brake_changes_configurationFlow_storeAction', firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_hasToBeChangedToTrue);
            dispatch('get_bowdenwireSelection_storeAction');
            dispatch('get_brakeConnectionSelection_storeAction');
            dispatch('get_rotatedBrakeReleaseSelection_storeAction');
        }
    },
    async checkIf_changesAt_elevatorMotor_Brake_changes_configurationFlow_storeAction({ rootState, dispatch }, value) {
        dispatch('change_Selected_at_elevatorMotor_Brake_Selection_storeAction', value)
        dispatch('change_Selected_at_elevatorMotor_Brake_Voltage_Selection_basedOnChangesTo_Selected_at_elevatorMotor_Brake_Selection_storeAction');
        dispatch('change_Selected_at_elevatorMotor_Brake_MechanicalRelease_Selection_basedOnChangesTo_Selected_at_elevatorMotor_Brake_Selection_storeAction');
        dispatch('change_Selected_at_elevatorMotor_Brake_ReleaseMonitoring_Selection_basedOnChangesTo_Selected_at_elevatorMotor_Brake_Selection_storeAction');
        dispatch('change_Disabled_at_elevatorMotor_Brake_MechanicalRelease_Selection_basedOnChangesTo_Selected_at_elevatorMotor_Brake_Selection_storeAction');
        dispatch('change_Disabled_at_elevatorMotor_Brake_ReleaseMonitoring_Selection_basedOnChangesTo_Selected_at_elevatorMotor_Brake_Selection_storeAction');
    },

    // elevatorMotor_Brake_Voltage
    change_Selected_at_elevatorMotor_Brake_Voltage_Selection_basedOnChangesTo_Selected_at_elevatorMotor_Brake_Selection_storeAction({ dispatch }) {
        const firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => i.selected == true);

        if (firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue > -1) {
            const firstIndexWhere_Selected_at_elevatorMotor_Brake_Voltage_Selection_mustBeChangedToTrue = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Voltage_Selection.findIndex(i => i.nominalVoltage == state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue].elevatorMotor_Brake.nominalVoltage);
            if (firstIndexWhere_Selected_at_elevatorMotor_Brake_Voltage_Selection_mustBeChangedToTrue > -1) {
                dispatch('change_Selected_atElementOf_elevatorMotor_Brake_Voltage_Selection_storeAction', firstIndexWhere_Selected_at_elevatorMotor_Brake_Voltage_Selection_mustBeChangedToTrue);
            }
            else {
                // error
            }
        }
        else {
            // error
        }
    },
    change_Selected_atElementOf_elevatorMotor_Brake_Voltage_Selection_storeAction({ commit }, value) {
        commit('change_Selected_at_elevatorMotor_Brake_Voltage_Selection_storeMutation', value);
    },

    // elevatorMotor_Brake_MechanicalRelease
    change_Selected_at_elevatorMotor_Brake_MechanicalRelease_Selection_basedOnChangesTo_Selected_at_elevatorMotor_Brake_Selection_storeAction({ dispatch }) {
        const firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => i.selected == true);

        if (firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue > -1) {
            const firstIndexWhere_Selected_at_elevatorMotor_Brake_MechanicalRelease_Selection_mustBeChangedToTrue = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_MechanicalRelease_Selection.findIndex(i => i.text == state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue].elevatorMotor_Brake.mechanicalRelease);
            if (firstIndexWhere_Selected_at_elevatorMotor_Brake_MechanicalRelease_Selection_mustBeChangedToTrue > -1) {
                dispatch('change_Selected_atElementOf_elevatorMotor_Brake_MechanicalRelease_Selection_storeAction', firstIndexWhere_Selected_at_elevatorMotor_Brake_MechanicalRelease_Selection_mustBeChangedToTrue);
            }
            else {
                // error
            }
        }
        else {
            // error
        }
    },
    change_Selected_atElementOf_elevatorMotor_Brake_MechanicalRelease_Selection_storeAction({ commit, dispatch }, value) {
        commit('change_Selected_at_elevatorMotor_Brake_MechanicalRelease_Selection_storeMutation', value);
    },
    change_Disabled_at_elevatorMotor_Brake_MechanicalRelease_Selection_basedOnChangesTo_Selected_at_elevatorMotor_Brake_Selection_storeAction({ commit }) {
        var helpArray_elevatorMotor_Brake_MechanicalRelease_Selection = [];

        const firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => i.selected == true);
        if (firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue > -1) {
            state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.forEach(i => {
                if (i.elevatorMotor_Brake.nominalVoltage == state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue].elevatorMotor_Brake.nominalVoltage) {
                    var helpArray_containsCurrentItemOf_elevatorMotor_Brake_MechanicalRelease_Selection = false;
                    helpArray_elevatorMotor_Brake_MechanicalRelease_Selection.forEach(ii => {
                        if (i.elevatorMotor_Brake.mechanicalRelease == ii.text) {
                            helpArray_containsCurrentItemOf_elevatorMotor_Brake_MechanicalRelease_Selection = true;
                        }
                    })
                    if (!helpArray_containsCurrentItemOf_elevatorMotor_Brake_MechanicalRelease_Selection) {
                        helpArray_elevatorMotor_Brake_MechanicalRelease_Selection.push(i.elevatorMotor_Brake.mechanicalRelease)
                    }
                }
            })
        }
        else {
            // error
        }

        if (helpArray_elevatorMotor_Brake_MechanicalRelease_Selection.length > 0) {
            commit('change_Disabled_at_elevatorMotor_Brake_MechanicalRelease_Selection_storeMutation', helpArray_elevatorMotor_Brake_MechanicalRelease_Selection)
        }
    },


    // elevatorMotor_Brake_ReleaseMonitoring
    change_Selected_at_elevatorMotor_Brake_ReleaseMonitoring_Selection_basedOnChangesTo_Selected_at_elevatorMotor_Brake_Selection_storeAction({ dispatch }) {
        const firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => i.selected == true);

        if (firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue > -1) {
            const firstIndexWhere_Selected_at_elevatorMotor_Brake_ReleaseMonitoring_Selection_mustBeChangedToTrue = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_ReleaseMonitoring_Selection.findIndex(i => i.text == state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue].elevatorMotor_Brake.releaseMonitoring);
            if (firstIndexWhere_Selected_at_elevatorMotor_Brake_ReleaseMonitoring_Selection_mustBeChangedToTrue > -1) {
                dispatch('change_Selected_atElementOf_elevatorMotor_Brake_ReleaseMonitoring_Selection_storeAction', firstIndexWhere_Selected_at_elevatorMotor_Brake_ReleaseMonitoring_Selection_mustBeChangedToTrue);
            }
            else {
                // error
            }
        }
        else {
            // error
        }
    },
    change_Selected_atElementOf_elevatorMotor_Brake_ReleaseMonitoring_Selection_storeAction({ commit }, value) {
        commit('change_Selected_at_elevatorMotor_Brake_ReleaseMonitoring_Selection_storeMutation', value);
    },
    change_Disabled_at_elevatorMotor_Brake_ReleaseMonitoring_Selection_basedOnChangesTo_Selected_at_elevatorMotor_Brake_Selection_storeAction({ commit }) {
        var helpArray_elevatorMotor_Brake_ReleaseMonitoring_Selection = [];

        const firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => i.selected == true);
        if (firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue > -1) {
            state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.forEach(i => {
                var helpArray_containsCurrentItemOf_elevatorMotor_Brake_ReleaseMonitoring_Selection = false;
                if ((i.elevatorMotor_Brake.nominalVoltage == state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue].elevatorMotor_Brake.nominalVoltage) && (i.elevatorMotor_Brake.withMechanicalRelease) && (i.elevatorMotor_Brake.mechanicalRelease == state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue].elevatorMotor_Brake.mechanicalRelease)) {
                    helpArray_elevatorMotor_Brake_ReleaseMonitoring_Selection.forEach(ii => {
                        if (ii.text == i.elevatorMotor_Brake.releaseMonitoring) {
                            helpArray_containsCurrentItemOf_elevatorMotor_Brake_ReleaseMonitoring_Selection = true;
                        }
                    })
                    if (!helpArray_containsCurrentItemOf_elevatorMotor_Brake_ReleaseMonitoring_Selection) {
                        helpArray_elevatorMotor_Brake_ReleaseMonitoring_Selection.push(i.elevatorMotor_Brake.releaseMonitoring)
                    }
                }
                else if ((i.elevatorMotor_Brake.nominalVoltage == state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue].elevatorMotor_Brake.nominalVoltage) && (!i.elevatorMotor_Brake.withMechanicalRelease) && (state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_at_elevatorMotor_Brake_Selection_isTrue].elevatorMotor_Brake.mechanicalRelease == 'without')) {
                    helpArray_elevatorMotor_Brake_ReleaseMonitoring_Selection.forEach(ii => {
                        if (ii.text == i.elevatorMotor_Brake.releaseMonitoring) {
                            helpArray_containsCurrentItemOf_elevatorMotor_Brake_ReleaseMonitoring_Selection = true;
                        }
                    })
                    if (!helpArray_containsCurrentItemOf_elevatorMotor_Brake_ReleaseMonitoring_Selection) {
                        helpArray_elevatorMotor_Brake_ReleaseMonitoring_Selection.push(i.elevatorMotor_Brake.releaseMonitoring)
                    }
                }
            })
        }
        else {
            // error
        }

        if (helpArray_elevatorMotor_Brake_ReleaseMonitoring_Selection.length > 0) {
            commit('change_Disabled_at_elevatorMotor_Brake_ReleaseMonitoring_Selection_storeMutation', helpArray_elevatorMotor_Brake_ReleaseMonitoring_Selection)
        }
    },
    // elevatorMotor_Brake_Connection
    async get_bowdenwireSelection_storeAction({ rootState, commit, dispatch, rootGetters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        const firstIndexWhere_Selected_brake = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => i.selected == true);
        if (firstIndexWhere_Selected_brake > -1) {
            const tnbow = rootGetters['inputsManual/hasMotorManualData'] ? rootState.inputsManual.motorManualData.details.tnbow : null;
            const lspezb = rootGetters['inputsManual/hasMotorManualData'] ? rootState.inputsManual.motorManualData.details.lspezb : null;

            const bhl = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_brake].elevatorMotor_Brake.mechanicalRelease;
            const bksich = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_brake].elevatorMotor_Brake.releaseMonitoring;
            const bcspae = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_brake].elevatorMotor_Brake.switchOnVoltage;
            const bcspan = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_brake].elevatorMotor_Brake.nominalVoltage;
            if (bcspae == null) { bcspae = bcspan; }

            const inputData = (rootState.inputsManual.psg === true) ? rootGetters['psgModal/inputData'] : rootGetters['inputsManual/inputData'];
            const data = {
                deliverRope: inputData.lSEILS,
                motorType: inputData.mTYP,
                motorSize: inputData.mBG,
                motorPackage: inputData.mFE,
                motorZusatz: inputData.mZUS,
                motorVoltage: inputData.mU1,
                motorRatedSpeed: inputData.mNR,
                mLS_Law: inputData.mLS_Law,
                temperatureMonitoring: inputData.mSART,
                tractionSheaveDiameter: inputData.tD,
                tractionSheaveWidth: inputData.tB,
                kid: rootState.manualHome.kid,
                sM250_TS280: inputData.sM250_TS280,
                deliverCover: inputData.lTSABD,
                deliverRopeClamp: inputData.lTKLEM,
                lruev: inputData.lRUEV,
                motorPosition: inputData.fUESSE,
                ropePull: inputData.sEILAB,
                adjustability: inputData.eINST,
                bhl: bhl,
                bcspae: bcspae,
                bcspan: bcspan,
                bksich: bksich,
                psgProdAP: inputData.psg_ProdAP,
                pSG_Handradanbau: inputData.pSG_Handradanbau,
                pSG_Handlueftung: inputData.pSG_Handlueftung,
                pSG_Kabellaenge: inputData.pSG_Kabellaenge,
                pSG_KabellaengeBremse: inputData.pSG_KabellaengeBremse,
                pSG_Reglerart: inputData.pSG_Reglerart,
                pSG_NAM: inputData.pSG_NAM,
                pSG_Rillenform: inputData.pSG_Rillenform,
                pSG_Controller: inputData.psG_Controller,
                pSG_ID: inputData.psg_ID,
                mfbtyp: inputData.mFBTYP,
                mip: inputData.mIP,
                tnbow: tnbow,
                lspezb: lspezb,
            }

            await axios({
                method: 'post',
                url: '/api/driveTechnologiesManual/get_bowdenwireSelection',
                data: {
                    data: data,
                },
            })
                .then((response) => {
                    if (response != null && response.data != null && response.data.deliver != null) {
                        commit('change_bowdenwireDeliverSelection_storeMutation', response.data.deliver);
                        commit('change_bowdenwireDetailsSelection_storeMutation', response.data.details);
                    }
                })
                .catch(() => {
                })
                .then(() => {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });

                })
        }
    },
    async change_bowdenwireDeliver_configuration_storeAction({ commit, dispatch }, value) {
        if (value == null) {
            await commit('change_bowdenwireDeliverSelected_storeMutation', null);
            await commit('change_bowdenwireDetailsSelected_storeMutation', null);
        }
        else {
            await commit('change_bowdenwireDeliverSelected_storeMutation', value.text.text);
            if (value.text.code == null || value.text.code == 0) {
                await commit('change_bowdenwireDetailsSelected_storeMutation', null);
            }
        }
    },
    async change_bowdenwireDetails_configuration_storeAction({ commit, dispatch }, value) {
        if (value == null) {
            await commit('change_bowdenwireDetailsSelected_storeMutation', null);
        }
        else {
            await commit('change_bowdenwireDetailsSelected_storeMutation', value.blockNumber);
        }
    },

    // elevatorMotor_Brake_Connection
    async get_brakeConnectionSelection_storeAction({ rootState, commit, dispatch, rootGetters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        const firstIndexWhere_Selected_brake = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => i.selected == true);
        if (firstIndexWhere_Selected_brake > -1) {
            var tnzbb = null;
            if (rootGetters['inputsManual/hasMotorManualData']) {
                tnzbb = rootState.inputsManual.motorManualData.details.tnzbb;
            }

            var bksich = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_brake].elevatorMotor_Brake.releaseMonitoring;
            var bcspae = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_brake].elevatorMotor_Brake.switchOnVoltage;
            var bcspan = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_brake].elevatorMotor_Brake.nominalVoltage;
            if (bcspae == null) { bcspae = bcspan; }

            const inputData = (rootState.inputsManual.psg === true) ? rootGetters['psgModal/inputData'] : rootGetters['inputsManual/inputData'];

            const data = {
                deliverRope: inputData.lSEILS,
                motorType: inputData.mTYP,
                motorSize: inputData.mBG,
                motorPackage: inputData.mFE,
                motorZusatz: inputData.mZUS,
                motorVoltage: inputData.mU1,
                motorRatedSpeed: inputData.mNR,
                mLS_Law: inputData.mLS_Law,
                temperatureMonitoring: inputData.mSART,
                tractionSheaveDiameter: inputData.tD,
                tractionSheaveWidth: inputData.tB,
                kid: rootState.manualHome.kid,
                sM250_TS280: inputData.sM250_TS280,
                deliverCover: inputData.lTSABD,
                deliverRopeClamp: inputData.lTKLEM,
                lruev: inputData.lRUEV,
                motorPosition: inputData.fUESSE,
                ropePull: inputData.sEILAB,
                adjustability: inputData.eINST,
                bcspae: bcspae,
                bcspan: bcspan,
                bksich: bksich,
                psgProdAP: inputData.psg_ProdAP,
                pSG_Handradanbau: inputData.pSG_Handradanbau,
                pSG_Handlueftung: inputData.pSG_Handlueftung,
                pSG_Kabellaenge: inputData.pSG_Kabellaenge,
                pSG_KabellaengeBremse: inputData.pSG_KabellaengeBremse,
                pSG_Reglerart: inputData.pSG_Reglerart,
                pSG_NAM: inputData.pSG_NAM,
                pSG_Rillenform: inputData.pSG_Rillenform,
                pSG_Controller: inputData.psG_Controller,
                pSG_ID: inputData.psg_ID,
                mfbtyp: inputData.mFBTYP,
                mip: inputData.mIP,
                tnzbb: tnzbb,
            }

            await axios({
                method: 'post',
                url: '/api/driveTechnologiesManual/get_brakeConnectionSelection',
                data: {
                    data: data,
                },
            })
                .then((response) => {
                    commit('change_brakeConnectionSelection_storeMutation', response.data);
                })
                .catch(() => {
                })
                .then(() => {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });

                })
        }
    },

    change_brakeConnection_configuration_storeAction({ commit, dispatch }, value) {
        if (value == null) {
            commit('change_brakeConnectionSelected_storeMutation', null);
        }
        else {
            commit('change_brakeConnectionSelected_storeMutation', value.blockNumber);
        }
    },

    //elevatorMotor_Brake_RotatedBrakeRelease
    async get_rotatedBrakeReleaseSelection_storeAction({ rootState, commit, dispatch, rootGetters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        const firstIndexWhere_Selected_brake = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => i.selected == true);
        if (firstIndexWhere_Selected_brake > -1) {
            var llaghl = null;
            if (rootGetters['inputsManual/hasMotorManualData']) {
                llaghl = rootState.inputsManual.motorManualData.details.llaghl;
            }

            const inputData = (rootState.inputsManual.psg === true) ? rootGetters['psgModal/inputData'] : rootGetters['inputsManual/inputData'];

            const data = {
                kid: rootState.manualHome.kid,
                pSG_Controller: inputData.psG_Controller,
                psgProdAP: inputData.psg_ProdAP,
                temperatureMonitoring: inputData.mSART,
                llaghl: llaghl,
                mN_BREM: state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[firstIndexWhere_Selected_brake].elevatorMotor_Brake.blockNumber,
                mfbtyp: inputData.mFBTYP,
                motorType: inputData.mTYP,
                motorSize: inputData.mBG,
                motorPackage: inputData.mFE,
                motorZusatz: inputData.mZUS,
                motorVoltage: inputData.mU1,
                motorRatedSpeed: inputData.mNR,
                mLS_Law: inputData.mLS_Law,
                sM250_TS280: inputData.sM250_TS280,
                pSG_Handradanbau: inputData.pSG_Handradanbau,
                pSG_Handlueftung: inputData.pSG_Handlueftung,
                pSG_Kabellaenge: inputData.pSG_Kabellaenge,
                pSG_KabellaengeBremse: inputData.pSG_KabellaengeBremse,
                pSG_Reglerart: inputData.pSG_Reglerart,
                pSG_NAM: inputData.pSG_NAM,
                pSG_Rillenform: inputData.pSG_Rillenform,
                pSG_ID: inputData.psg_ID,
            }

            await axios({
                method: 'post',
                url: '/api/driveTechnologiesManual/get_rotatedBrakeReleaseSelection',
                data: {
                    data: data,
                },
            })
                .then((response) => {
                    commit('change_rotatedBrakeReleaseSelection_storeMutation', response.data);
                })
                .catch(() => {
                })
                .then(() => {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });

                })
        }
    },

    change_rotatedBrakeRelease_configuration_storeAction({ commit, dispatch }, value) {
        if (value == null) {
            commit('change_rotatedBrakeReleaseSelected_storeMutation', null);
        }
        else {
            commit('change_rotatedBrakeReleaseSelected_storeMutation', value.value);
        }
    },

    // elevatorMotor_Encoder
    change_elevatorMotor_Encoder_toDefault_storeAction({ commit }) {
        commit('change_elevatorMotor_Encoder_Data_storeMutation', {});
        commit('change_elevatorMotor_Encoder_Selection_Shown_storeMutation', true)
    },

    async get_elevatorMotor_Encoder_Informations_storeAction({ dispatch, rootState, rootGetters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        var mn_ENC = null;

        if (rootGetters['inputsManual/hasMotorManualData']) {
            mn_ENC = rootState.inputsManual.motorManualData.details.mN_ENC;
        }

        const inputData = (rootState.inputsManual.psg === true) ? rootGetters['psgModal/inputData'] : rootGetters['inputsManual/inputData'];

        const motorManual = {
            mTYP: inputData.mTYP,
            mBG: inputData.mBG,
            mFE: inputData.mFE,
            mZUS: inputData.mZUS,
            mU1: inputData.mU1,
            mNR: inputData.mNR,
            mLS_Law: inputData.mLS_Law,
            motor_Preference: inputData.motor_Preference,
            mSART: inputData.mSART,
            mIP: inputData.mIP,
            motor_ForcedVentilationWithBrakeRelease: inputData.motor_ForcedVentilationWithBrakeRelease,
            mFBTYP: inputData.mFBTYP,
            lTR: inputData.lTR,
            lTHD: inputData.lTHD,
            tD: inputData.tD,
            tB: inputData.tB,
            tARILL: inputData.tARILL,
            tAUWI: inputData.tAUWI,
            tAKWI: inputData.tAKWI,
            tCSD: inputData.tCSD,
            tDRA: inputData.tDRA,
            tDRZ: inputData.tDRZ,
            kIDSCH: inputData.kIDSCH,
            fUESSE: inputData.fUESSE,
            sEILAB: inputData.sEILAB,
            eINST: inputData.eINST,
            lSEILS: inputData.lSEILS,
            lTSABD: inputData.lTSABD,
            lTKLEM: inputData.lTKLEM,
            lRUEV: inputData.lRUEV,
            mN_SAS: inputData.mN_SAS,
            lTHD: inputData.lTHD,
            sM250_TS280: inputData.sM250_TS280,
            pSG_ProdAP: inputData.psg_ProdAP,
            pSG_Handradanbau: inputData.pSG_Handradanbau,
            pSG_Handlueftung: inputData.pSG_Handlueftung,
            pSG_Kabellaenge: inputData.pSG_Kabellaenge,
            pSG_KabellaengeBremse: inputData.pSG_KabellaengeBremse,
            pSG_Reglerart: inputData.pSG_Reglerart,
            pSG_NAM: inputData.pSG_NAM,
            pSG_Rillenform: inputData.pSG_Rillenform,
            pSG_Controller: inputData.psG_Controller,
            pSG_ID: inputData.pSG_ID,
            PSG_MBG: inputData.psg_MBG,
            mN_ENC: mn_ENC,
        }

        const data = {
            motorManual: motorManual,
            kid: rootState.manualHome.kid,
        }

        await axios({
            method: 'post',
            url: '/api/driveTechnologiesManual/get_elevatorMotor_Encoder_Informations',
            data: {
                data: data,
            }
        })
            .then((response) => {
                this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);

                if ((response.data.status.statusCode.substring(0, 1) == '2') || (response.data.status.statusCode.substring(0, 2) == '74') || (response.data.status.statusCode.substring(0, 2) == '75')) {
                    dispatch('toDos_afterResponseOf_get_elevatorMotor_Encoder_Informations_storeAction', response.data.data);
                    if (state.elevatorMotor_Encoder_Data != null && state.elevatorMotor_Encoder_Data.hasOwnProperty('elevatorMotor_Encoder_Selection')) {
                        const firstIndex_whichMeetConditions = state.elevatorMotor_Encoder_Data.elevatorMotor_Encoder_Selection.findIndex(i => i.selected == true);
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_Selected_at_elevatorMotor_Encoder_Selection_storeAction', firstIndex_whichMeetConditions);
                        }
                        else {
                            dispatch('change_Selected_atFirstElementOf_elevatorMotor_Encoder_Selection_toTrue_storeAction');
                        }
                    }
                    else {
                        dispatch('change_Selected_atFirstElementOf_elevatorMotor_Encoder_Selection_toTrue_storeAction');
                    }
                }
            })
            .catch(() => { })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },
    toDos_afterResponseOf_get_elevatorMotor_Encoder_Informations_storeAction({ rootState, dispatch }, value) {
        dispatch('change_elevatorMotor_Encoder_Data_storeAction', value.elevatorMotor_Encoder_Data);
    },

    change_elevatorMotor_Encoder_Data_storeAction({ commit }, value) {
        commit('change_elevatorMotor_Encoder_Data_storeMutation', value);
    },
    change_elevatorMotor_Encoder_Selection_Shown_storeAction({ commit }, value) {
        commit('change_elevatorMotor_Encoder_Selection_Shown_storeMutation', value)
    },
    async change_Selected_atFirstElementOf_elevatorMotor_Encoder_Selection_toTrue_storeAction({ dispatch }) {
        dispatch('change_Selected_at_elevatorMotor_Encoder_Selection_storeAction', 0);
    },
    async checkIf_changesAt_elevatorMotor_Encoder_changes_configurationFlow_storeAction({ rootState, commit, dispatch }, value) {
        dispatch('change_Selected_at_elevatorMotor_Encoder_Selection_storeAction', value)
    },
    change_Selected_at_elevatorMotor_Encoder_Selection_storeAction({ commit }, value) {
        commit('change_Selected_at_elevatorMotor_Encoder_Selection_storeMutation', value);
    },


    async insertOrUpdate_motorManual_storeAction({ rootState, dispatch, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const motorManual = getters.motorManualDatabase
        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            kid: rootState.manualHome.kid,
            motorManual: motorManual,
        }
        await axios({
            method: 'post',
            url: '/api/configurations/insertOrUpdate_motor',
            data: {
                data: data,
            }
        })
            .then((response) => {
                this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                if (response.data.status.statusCode.substring(0, 1) == '2') {
                    if (response.data.data.changedDataset == true) {
                        this.dispatch('manualHome/change_configurationOverviewsManualId_storeAction', response.data.data.configurationOverviewsManualId);
                    }
                    this.commit('psgModal/change_SCH_psgMenu_storeMutation', false)
                    dispatch('furtherTo', response.data.data.furtherToFrame);
                    
                }
                else {
                }

            })
            .catch(() => { })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },

    async furtherTo({ }, value) {
        if (value != null && value == true) {
            router.push('../manualStep/frameManual');
        }
        else {
            router.push('../manualStep/cables');
        }
    },

    checkIf_driveTechnologiesManual_areValid_storeAction({ rootState, dispatch }) {
        var numberOf_inputs_whichAreInvalid = 0;

        const firstIndexWhere_Selected_brake = state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.findIndex(i => i.selected == true);
        const fristIndexWhere_Selected_brakeConnection = state.brakeConnectionSelection.findIndex(i => i.selected == true);
        const firstIndexWhere_Selected_encoder = state.elevatorMotor_Encoder_Data.elevatorMotor_Encoder_Selection.findIndex(i => i.selected == true);

        if (firstIndexWhere_Selected_brake == -1) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
            this.dispatch('statusHandling/change_dataAndStatus_storeAction', { status: { statusCode: '7200001', statusInContextOf: 'checkIf_inputs_areValid_storeAction', statusInformations: [{ textKey: 1541 }], statusModalClosingOptions: [{ displayedDesignation: { textKey: 383 }, closingOption: 'close' }] } })
        }
        else {
            if (fristIndexWhere_Selected_brakeConnection == -1 || state.brakeConnectionSelection[fristIndexWhere_Selected_brakeConnection].blockNumber == null) {
                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
                this.dispatch('statusHandling/change_dataAndStatus_storeAction', { status: { statusCode: '7200001', statusInContextOf: 'checkIf_inputs_areValid_storeAction', statusInformations: [{ textKey: 3621 }], statusModalClosingOptions: [{ displayedDesignation: { textKey: 383 }, closingOption: 'close' }] } })
            }
            if (state.bowdenwireDeliverSelection != null && state.bowdenwireDeliverSelection.length > 0) {
                const firstIndexWhere_Selected_bowdenwireDeliver = state.bowdenwireDeliverSelection.findIndex(i => i.selected == true);
                if (firstIndexWhere_Selected_bowdenwireDeliver == -1) {
                    numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
                    this.dispatch('statusHandling/change_dataAndStatus_storeAction', { status: { statusCode: '7200001', statusInContextOf: 'checkIf_inputs_areValid_storeAction', statusInformations: [{ textKey: 3621 }], statusModalClosingOptions: [{ displayedDesignation: { textKey: 383 }, closingOption: 'close' }] } })
                }
                else {
                    if (state.bowdenwireDeliverSelection[firstIndexWhere_Selected_bowdenwireDeliver].showDetails === true && (state.bowdenwireDeliverSelection[firstIndexWhere_Selected_bowdenwireDeliver].text.code != null && state.bowdenwireDeliverSelection[firstIndexWhere_Selected_bowdenwireDeliver].text.code > 0)) {
                        const firstIndexWhere_Selected_bowdenwireDetails = state.bowdenwireDetailsSelection.findIndex(i => i.selected == true);
                        if (firstIndexWhere_Selected_bowdenwireDetails == -1) {
                            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
                            this.dispatch('statusHandling/change_dataAndStatus_storeAction', { status: { statusCode: '7200001', statusInContextOf: 'checkIf_inputs_areValid_storeAction', statusInformations: [{ textKey: 3621 }], statusModalClosingOptions: [{ displayedDesignation: { textKey: 383 }, closingOption: 'close' }] } })
                        }

                    }
                }

            }
        }
        if (state.rotatedBrakeReleaseSelection.length > 0) {
            const fristIndexWhere_Selected_rotatedBrakeRelease = state.rotatedBrakeReleaseSelection.findIndex(i => i.selected == true);
            if (fristIndexWhere_Selected_rotatedBrakeRelease == -1 || state.rotatedBrakeReleaseSelection[fristIndexWhere_Selected_rotatedBrakeRelease].value == null) {
                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
                this.dispatch('statusHandling/change_dataAndStatus_storeAction', { status: { statusCode: '7200001', statusInContextOf: 'checkIf_inputs_areValid_storeAction', statusInformations: [{ textKey: 3621 }], statusModalClosingOptions: [{ displayedDesignation: { textKey: 383 }, closingOption: 'close' }] } })
            }
        }
        if (firstIndexWhere_Selected_encoder == -1) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
            this.dispatch('statusHandling/change_dataAndStatus_storeAction', { status: { statusCode: '7200001', statusInContextOf: 'checkIf_inputs_areValid_storeAction', statusInformations: [{ textKey: 1542 }], statusModalClosingOptions: [{ displayedDesignation: { textKey: 383 }, closingOption: 'close' }] } })
        }

        if (numberOf_inputs_whichAreInvalid > 0) {
        }
        else if (numberOf_inputs_whichAreInvalid == 0) {
            dispatch('insertOrUpdate_motorManual_storeAction');
        }
    },
}

const mutations = {
    change_elevatorMotor_Machine_Manual_storeMutation(state, payload) {
        state.elevatorMotor_Machine_Manual = payload;
    },

    // elevatorMotor_Brake
    change_elevatorMotor_Brake_Manual_Data_storeMutation(state, payload) {
        state.elevatorMotor_Brake_Manual_Data = Object.assign({}, payload);
    },
    change_Selected_at_elevatorMotor_Brake_Selection_storeMutation(state, payload) {
        for (let i = 0; i < state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.length; i++) {
            state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[i].selected = false;
            if (i == payload) {
                state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection[i].selected = true;
            }
        }
    },
    change_elevatorMotor_Brake_Selections_Shown_storeMutation(state, payload) {
        state.elevatorMotor_Brake_Selections_Shown = payload;
    },

    change_loader_forLoadingData_at_elevatorMotor_Brake_Shown_storeMutation(state, payload) {
        state.loader_forLoadingData_at_elevatorMotor_Brake_Shown = payload;
    },
    abort_httpRequests_get_elevatorMotor_Brake_Informations_storeMutation(state) {
        state.cancellationInformationsAboutHttpRequests_get_elevatorMotor_Brake_Informations.abort();
    },
    change_cancellationInformationsAboutHttpRequests_get_elevatorMotor_Brake_Informations_toNewAbortController_storeMutation(state) {
        state.cancellationInformationsAboutHttpRequests_get_elevatorMotor_Brake_Informations = new AbortController();
    },

    // elevatorMotor_Brake_Voltage
    change_Selected_at_elevatorMotor_Brake_Voltage_Selection_storeMutation(state, payload) {
        for (let i = 0; i < state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Voltage_Selection.length; i++) {
            state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Voltage_Selection[i].selected = false;
            if (i == payload) {
                state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Voltage_Selection[i].selected = true;
            }
        }
    },

    // elevatorMotor_Brake_MechanicalRelease
    change_Selected_at_elevatorMotor_Brake_MechanicalRelease_Selection_storeMutation(state, payload) {
        for (let i = 0; i < state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_MechanicalRelease_Selection.length; i++) {
            state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_MechanicalRelease_Selection[i].selected = false;
            if (i == payload) {
                state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_MechanicalRelease_Selection[i].selected = true;
            }
        }
    },
    change_Disabled_at_elevatorMotor_Brake_MechanicalRelease_Selection_storeMutation(state, payload) {
        state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_MechanicalRelease_Selection.forEach(i => {
            const item_whichMustNotBeDisabled = payload.some(ii => ii == i.text);
            i.disabled = true;
            if (item_whichMustNotBeDisabled) {
                i.disabled = false;
            }
        })
    },
    change_elevatorMotor_Brake_MechanicalRelease_ChangedByUser_storeMutation(state, payload) {
        state.elevatorMotor_Brake_MechanicalRelease_ChangedByUser = payload;
    },

    // elevatorMotor_Brake_ReleaseMonitoring
    change_Selected_at_elevatorMotor_Brake_ReleaseMonitoring_Selection_storeMutation(state, payload) {
        for (let i = 0; i < state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_ReleaseMonitoring_Selection.length; i++) {
            state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_ReleaseMonitoring_Selection[i].selected = false;
            if (i == payload) {
                state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_ReleaseMonitoring_Selection[i].selected = true;
            }
        }
    },
    change_Disabled_at_elevatorMotor_Brake_ReleaseMonitoring_Selection_storeMutation(state, payload) {
        state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_ReleaseMonitoring_Selection.forEach(i => {
            const item_whichMustNotBeDisabled = payload.some(ii => ii == i.text);
            i.disabled = true;
            if (item_whichMustNotBeDisabled) {
                i.disabled = false;
            }
        })
    },
    change_elevatorMotor_Brake_ReleaseMonitoring_ChangedByUser_storeMutation(state, payload) {
        state.elevatorMotor_Brake_ReleaseMonitoring_ChangedByUser = payload;
    },

    // elevatorMotor_Brake_Bowdenwire_BrakeConnection_rotatedBrakeRelease
    change_bowdenwireDeliverSelection_storeMutation(state, payload) {
        state.bowdenwireDeliverSelection = payload;
    },
    change_bowdenwireDeliverSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.bowdenwireDeliverSelection.length; i++) {
            state.bowdenwireDeliverSelection[i].selected = false;
            if (payload != null && payload != '' && state.bowdenwireDeliverSelection[i].text.text == payload) {
                state.bowdenwireDeliverSelection[i].selected = true;
            }
        }
    },
    change_bowdenwireDetailsSelection_storeMutation(state, payload) {
        state.bowdenwireDetailsSelection = payload;
    },
    change_bowdenwireDetailsSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.bowdenwireDetailsSelection.length; i++) {
            state.bowdenwireDetailsSelection[i].selected = false;
            if (payload != null && payload != '' && state.bowdenwireDetailsSelection[i].blockNumber == payload) {
                state.bowdenwireDetailsSelection[i].selected = true;
            }
        }
    },
    change_brakeConnectionSelection_storeMutation(state, payload) {
        state.brakeConnectionSelection = payload;
    },
    change_brakeConnectionSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.brakeConnectionSelection.length; i++) {
            state.brakeConnectionSelection[i].selected = false;
            if (payload != null && payload != '' && state.brakeConnectionSelection[i].blockNumber == payload) {
                state.brakeConnectionSelection[i].selected = true;
            }
        }
    },
    change_rotatedBrakeReleaseSelection_storeMutation(state, payload) {
        state.rotatedBrakeReleaseSelection = payload;
    },
    change_rotatedBrakeReleaseSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.rotatedBrakeReleaseSelection.length; i++) {
            state.rotatedBrakeReleaseSelection[i].selected = false;
            if (payload != null && state.rotatedBrakeReleaseSelection[i].value == payload) {
                state.rotatedBrakeReleaseSelection[i].selected = true;
            }
        }
    },

    // elevatorMotor_Encoder
    change_elevatorMotor_Encoder_Data_storeMutation(state, payload) {
        state.elevatorMotor_Encoder_Data = Object.assign({}, payload);
    },
    change_elevatorMotor_Encoder_Selection_Shown_storeMutation(state, payload) {
        state.elevatorMotor_Encoder_Selection_Shown = payload;
    },
    change_Selected_at_elevatorMotor_Encoder_Selection_storeMutation(state, payload) {
        for (let i = 0; i < state.elevatorMotor_Encoder_Data.elevatorMotor_Encoder_Selection.length; i++) {
            state.elevatorMotor_Encoder_Data.elevatorMotor_Encoder_Selection[i].selected = false;
            if (i == payload) {
                state.elevatorMotor_Encoder_Data.elevatorMotor_Encoder_Selection[i].selected = true;
            }
        }
    },

}

const getters = {
    motorManualDatabase: (state, getters, rootState, rootGetters) => {
        const mN_BREM = getters.brakeSelected.mN_BREM;
        const brakeNominalVoltage = getters.brakeSelected.brakeNominalVoltage;
        const bCSPAE = getters.brakeSelected.bCSPAE;
        const bHL = getters.brakeSelected.bHL;
        const bKSICH = getters.brakeSelected.bKSICH;
        const tNZBB = getters.brakeConnectionSelected.tNZBB;
        const sZBANS = getters.brakeConnectionSelected.sZBANS;
        const llaghl = getters.llaghl;
        const lSPEZB = getters.lspezb;
        const tnbow = getters.bowdenwireDetailsSelected.blockNumber;
        const sPEZBL = getters.bowdenwireDetailsSelected.length;
        const gTYP = getters.gtyp;
        const mN_MOT = rootGetters['inputsManual/motorSelection_mN_MOT'] != null ? rootGetters['inputsManual/motorSelection_mN_MOT'] : null;
        const mN_TS = rootGetters['inputsManual/tractionSheaveSelection_mN_TS'] != null ? rootGetters['inputsManual/tractionSheaveSelection_mN_TS'] : null;

        const inputData = (rootState.inputsManual.psg === true) ? rootGetters['psgModal/inputData'] : rootGetters['inputsManual/inputData'];

        return {
            mTYP: inputData.mTYP,
            mBG: inputData.mBG,
            mFE: inputData.mFE,
            mZUS: inputData.mZUS,
            sMU1: inputData.mU1,
            mNR: inputData.mNR,
            mLS_Law: inputData.mLS_Law,
            motor_Preference: inputData.motor_Preference,
            mSART: inputData.mSART,
            mIP: inputData.mIP,
            motor_ForcedVentilationWithBrakeRelease: inputData.motor_ForcedVentilationWithBrakeRelease,
            mFBTYP: inputData.mFBTYP,
            tNFB: inputData.tNFB,
            lTR: inputData.lTR,
            lTHD: inputData.lTHD,
            tD: inputData.tD,
            tB: inputData.tB,
            tARILL: inputData.tARILL,
            tAUWI: inputData.tAUWI,
            tAKWI: inputData.tAKWI,
            tCSD: inputData.tCSD,
            tDRA: inputData.tDRA,
            tDRZ: inputData.tDRZ,
            kIDSCH: inputData.kIDSCH,
            fUESSE: inputData.fUESSE,
            sEILAB: inputData.sEILAB,
            eINST: inputData.eINST,
            lSEILS: inputData.lSEILS,
            lTSABD: inputData.lTSABD,
            lTKLEM: inputData.lTKLEM,
            lRUEV: inputData.lRUEV,
            mN_SAS: inputData.mN_SAS,
            lTHD: inputData.lTHD,
            sM250_TS280: inputData.sM250_TS280,
            mN_BREM: mN_BREM,
            brakeNominalVoltage: brakeNominalVoltage,
            bCSPAE: bCSPAE,
            bHL: bHL,
            bKSICH: bKSICH,
            tNZBB: tNZBB,
            sZBANS: sZBANS,
            lSPEZB: lSPEZB,
            tnbow: tnbow,
            sPEZBL: sPEZBL,
            llaghl: llaghl,
            gTYP: gTYP,
            pSG_Handradanbau: inputData.pSG_Handradanbau,
            pSG_Handlueftung: inputData.pSG_Handlueftung,
            pSG_Kabellaenge: inputData.pSG_Kabellaenge,
            pSG_KabellaengeBremse: inputData.pSG_KabellaengeBremse,
            pSG_Reglerart: inputData.pSG_Reglerart,
            pSG_NAM: inputData.pSG_NAM,
            pSG_Rillenform: inputData.pSG_Rillenform,
            psg_Produktionsort: inputData.psg_Produktionsort,
            psg_Zertifizierung: inputData.psg_Zertifizierung,
            psg_ProdAP: inputData.psg_ProdAP,
            psg_Voltage: inputData.psg_Voltage,
            psg_GlobalID_BG: inputData.psg_GlobalID_BG,
            psg_MotorID: inputData.psg_MotorID,
            psg_Rillenabstand: inputData.psg_Rillenabstand,
            psg_No_of_rope_Grooves: inputData.psg_No_of_rope_Grooves,
            psg_MIb1: inputData.psg_MIb1,
            psg_MBG: inputData.psg_MBG,
            psg_MFE: inputData.psg_MFE,
            psg_ID: inputData.psg_ID,
            psg_MNR: inputData.psg_MNR,
            psG_Controller: inputData.psG_Controller,
            psG_OrderStatusMotorCable: inputData.psG_OrderStatusMotorCable,
            psG_OrderStatusEncoderCable: inputData.psG_OrderStatusEncoderCable,
            psG_OrderStatusMotorProtectionCable: inputData.psG_OrderStatusMotorProtectionCable,
            psG_OrderStatusBrakeCable: inputData.psG_OrderStatusBrakeCable,
            psG_OrderStatusBrakeMonitoringCable: inputData.psG_OrderStatusBrakeMonitoringCable,
            psG_OrderStatusForcedVentilationCable: inputData.psG_OrderStatusForcedVentilationCable,
            mN_Mot: mN_MOT,
            mN_TS: mN_TS,
        }
    },
    lspezb: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const lSPEZB = selected(state.bowdenwireDeliverSelection);
        return lSPEZB != null && lSPEZB.text != null ? lSPEZB.text.code : null;
    },
    bowdenwireDetailsSelected: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const bowdenwireSelected = selected(state.bowdenwireDetailsSelection)

        return {
            blockNumber: bowdenwireSelected != null ? bowdenwireSelected.blockNumber : null,
            length: bowdenwireSelected != null ? bowdenwireSelected.length : null,
        }
    },
    llaghl: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const llaghl = selected(state.rotatedBrakeReleaseSelection);
        return llaghl != null ? llaghl.value : null;
    },
    brakeSelected: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const brake = selected(state.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection);
        return {
            mN_BREM: brake != null && brake.elevatorMotor_Brake != null ? brake.elevatorMotor_Brake.blockNumber : null,
            brakeNominalVoltage: brake != null && brake.elevatorMotor_Brake != null ? brake.elevatorMotor_Brake.nominalVoltage : null,
            bCSPAE: brake != null && brake.elevatorMotor_Brake != null ? brake.elevatorMotor_Brake.switchOnVoltage : null,
            bHL: brake != null && brake.elevatorMotor_Brake != null ? brake.elevatorMotor_Brake.mechanicalRelease : null,
            bKSICH: brake != null && brake.elevatorMotor_Brake != null ? brake.elevatorMotor_Brake.releaseMonitoring : null,
        }
    },
    brakeConnectionSelected: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const brakeConnection = selected(state.brakeConnectionSelection);
        return {
            tNZBB: brakeConnection != null ? brakeConnection.blockNumber : null,
            sZBANS: brakeConnection != null ? brakeConnection.text : null,
        }
    },
    gtyp: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const gTYP = selected(state.elevatorMotor_Encoder_Data.elevatorMotor_Encoder_Selection);
        return gTYP != null && gTYP.elevatorMotor_Encoder != null ? gTYP.elevatorMotor_Encoder.typeDesignation : null;
    },
}

export const driveTechnologiesManual = {
    namespaced: true,
    components: {
        axios
    },
    state,
    actions,
    mutations,
    getters
}